import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSora = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_17396_28115)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.2525 9.26835e-08H3.74667C2.75299 9.26835e-08 1.80001 0.394737 1.09737 1.09737C0.394737 1.80001 9.26835e-08 2.75299 9.26835e-08 3.74667V16.2525C-0.000109358 16.7446 0.0967203 17.2319 0.284959 17.6865C0.473198 18.1412 0.749158 18.5543 1.09708 18.9023C1.445 19.2503 1.85807 19.5264 2.31269 19.7147C2.76731 19.9031 3.25458 20 3.74667 20H16.2525C16.7447 20.0001 17.232 19.9033 17.6867 19.715C18.1415 19.5267 18.5546 19.2506 18.9026 18.9026C19.2506 18.5546 19.5267 18.1415 19.715 17.6867C19.9033 17.232 20.0001 16.7447 20 16.2525V3.74667C20 3.25458 19.9031 2.76731 19.7147 2.31269C19.5264 1.85807 19.2503 1.445 18.9023 1.09708C18.5543 0.749158 18.1412 0.473198 17.6865 0.284959C17.2319 0.0967203 16.7446 -0.000109358 16.2525 9.26835e-08Z",
					fill: "url(#paint0_linear_17396_28115)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.10656 9.4668C8.17419 9.4668 8.23905 9.49366 8.28687 9.54148C8.3347 9.58931 8.36156 9.65417 8.36156 9.7218C8.36156 9.78943 8.3347 9.85429 8.28687 9.90211C8.23905 9.94993 8.17419 9.9768 8.10656 9.9768C8.03893 9.9768 7.97407 9.94993 7.92625 9.90211C7.87843 9.85429 7.85156 9.78943 7.85156 9.7218C7.85156 9.65417 7.87843 9.58931 7.92625 9.54148C7.97407 9.49366 8.03893 9.4668 8.10656 9.4668Z",
					fill: "url(#paint1_linear_17396_28115)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.00657 7.96738C7.03407 7.95988 7.06074 7.96904 7.08657 7.99487C7.2074 8.11987 7.3299 8.24321 7.45324 8.36738L7.47074 8.38071C7.47907 8.38488 7.4849 8.38821 7.49074 8.38904L7.9974 8.51988C8.0324 8.52821 8.05407 8.54738 8.06157 8.57488C8.06907 8.60404 8.0599 8.63071 8.03407 8.65654L7.66157 9.02237C7.65629 9.02784 7.65181 9.03401 7.64824 9.04071C7.6446 9.04698 7.6418 9.05371 7.6399 9.06071L7.50907 9.56654C7.50074 9.60154 7.48157 9.62321 7.45324 9.63071C7.4249 9.63904 7.39824 9.62904 7.37324 9.60321L7.00657 9.23154C6.99545 9.22108 6.98204 9.21337 6.9674 9.20904C6.79907 9.16487 6.6299 9.12154 6.46157 9.07904C6.42657 9.07071 6.4049 9.05154 6.3974 9.02237C6.38907 8.99487 6.39907 8.96738 6.4249 8.94238C6.5499 8.82071 6.67324 8.69904 6.7974 8.57571C6.80266 8.57055 6.80716 8.56465 6.81074 8.55821C6.81443 8.55167 6.81723 8.54466 6.81907 8.53738L6.9499 8.03154C6.95824 7.99654 6.9774 7.97488 7.00657 7.96738Z",
					fill: "url(#paint2_linear_17396_28115)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.3897 8.31878C12.4244 8.31679 12.4593 8.32192 12.492 8.33386C12.5247 8.3458 12.5546 8.36429 12.5799 8.3882C12.6053 8.41211 12.6254 8.44095 12.6392 8.47293C12.653 8.50491 12.6601 8.53937 12.6601 8.57419C12.6601 8.60902 12.653 8.64348 12.6392 8.67546C12.6254 8.70744 12.6053 8.73627 12.5799 8.76018C12.5546 8.7841 12.5247 8.80259 12.492 8.81453C12.4593 8.82646 12.4244 8.8316 12.3897 8.82961C12.3245 8.82588 12.2631 8.79735 12.2183 8.74986C12.1734 8.70237 12.1484 8.63952 12.1484 8.57419C12.1484 8.50887 12.1734 8.44602 12.2183 8.39853C12.2631 8.35104 12.3245 8.3225 12.3897 8.31878Z",
					fill: "url(#paint3_linear_17396_28115)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M11.2914 6.82319C11.3206 6.81486 11.3472 6.82486 11.3722 6.84986L11.7372 7.22319C11.7482 7.23324 11.7613 7.24066 11.7756 7.24486L12.2806 7.37653C12.3156 7.38486 12.3364 7.40403 12.3447 7.43319C12.3522 7.46069 12.3431 7.48736 12.3164 7.51236L11.9439 7.87736C11.9337 7.88834 11.926 7.90142 11.9214 7.91569L11.7906 8.41986C11.7822 8.45486 11.7622 8.47653 11.7339 8.48403C11.7056 8.49153 11.6789 8.48236 11.6539 8.45653C11.5331 8.33153 11.4114 8.20736 11.2897 8.08403C11.2844 8.07838 11.2782 8.0736 11.2714 8.06986C11.2649 8.06605 11.2579 8.06324 11.2506 8.06153L10.7464 7.92986C10.7114 7.92153 10.6897 7.90236 10.6822 7.87403C10.6747 7.84569 10.6839 7.81903 10.7097 7.79403C10.8347 7.67319 10.9581 7.55153 11.0822 7.42986C11.0878 7.42449 11.0926 7.41831 11.0964 7.41153C11.1001 7.40499 11.1029 7.39798 11.1047 7.39069L11.2364 6.88653C11.2447 6.85153 11.2639 6.82986 11.2914 6.82319Z",
					fill: "url(#paint4_linear_17396_28115)"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.55405 2.78624C8.156 2.53889 8.81122 2.44967 9.45739 2.52707C10.2907 2.62207 11.0332 2.97707 11.6849 3.58874C11.6936 3.59717 11.7042 3.60327 11.7159 3.60648C11.7275 3.60968 11.7398 3.60989 11.7516 3.60707C12.5988 3.38822 13.4956 3.46919 14.2899 3.83624L14.3291 3.85374L14.4257 3.90207C15.2571 4.32323 15.9056 5.03402 16.2491 5.90041C16.4232 6.32541 16.5107 6.76791 16.5124 7.22957C16.5249 7.57541 16.4874 7.91541 16.3999 8.24957C16.3952 8.26647 16.3951 8.28429 16.3995 8.30125C16.4038 8.31822 16.4126 8.33373 16.4249 8.34624C16.9199 8.85124 17.2482 9.45374 17.4107 10.1529C17.6516 11.3412 17.4049 12.4112 16.6716 13.3654L16.5582 13.5037C16.0725 14.0595 15.435 14.4612 14.7241 14.6596C14.7086 14.6641 14.6945 14.6723 14.6829 14.6835C14.6712 14.6947 14.6625 14.7085 14.6574 14.7237C14.4982 15.1829 14.3374 15.5762 14.0399 15.9687C13.2899 16.9571 12.1891 17.5071 10.9474 17.5004C9.95822 17.4954 9.08072 17.1337 8.31655 16.4154C8.30501 16.4044 8.2907 16.3967 8.27515 16.3932C8.25959 16.3897 8.24338 16.3905 8.22822 16.3954C7.90489 16.4996 7.57822 16.5154 7.22572 16.5112C6.66259 16.5066 6.10795 16.3735 5.60405 16.1221C5.07629 15.8604 4.61688 15.4792 4.26239 15.0087C4.13572 14.8412 4.00989 14.6829 3.91822 14.4954C3.79192 14.2381 3.68874 13.9701 3.60989 13.6946C3.44345 13.0673 3.43972 12.4079 3.59905 11.7787C3.60393 11.764 3.60535 11.7483 3.60322 11.7329C3.60043 11.7174 3.5925 11.7033 3.58072 11.6929C3.19546 11.3034 2.90095 10.8336 2.71822 10.3171C2.59713 9.99893 2.52683 9.66373 2.50989 9.32374C2.47953 8.87589 2.51917 8.42605 2.62739 7.99041C2.90822 7.06374 3.44572 6.33624 4.23822 5.80791C4.41489 5.69124 4.58155 5.59957 4.73905 5.53374C4.91822 5.45874 5.09739 5.39624 5.27739 5.34374C5.29023 5.33996 5.30191 5.33303 5.31138 5.32356C5.32084 5.3141 5.32778 5.30241 5.33155 5.28957C5.46788 4.79855 5.70263 4.34038 6.02155 3.94291C6.4243 3.43185 6.95216 3.03344 7.55405 2.78624ZM8.15655 7.56541C7.43572 7.05374 6.44989 7.30708 6.08739 8.11207C5.89905 8.52874 5.86239 8.96707 5.97655 9.42874L6.06655 9.79541L6.22905 10.3887C6.29572 10.7221 6.42239 11.0262 6.61155 11.3021L6.62989 11.3287C6.72989 11.4471 6.83989 11.5554 6.95822 11.6529C7.82405 12.3646 9.00489 11.8896 9.24072 10.8262L9.27155 10.6929L9.27989 10.6429C9.31655 10.3929 9.30489 10.1479 9.24655 9.90791C9.14198 9.48406 9.02806 9.06257 8.90489 8.64374C8.76905 8.18207 8.51989 7.82291 8.15655 7.56541ZM12.5966 6.53624C12.0582 6.03624 11.2274 6.01707 10.6924 6.52041C10.4841 6.71624 10.3382 6.98041 10.2566 7.31124C10.1752 7.64694 10.1752 7.99721 10.2566 8.33291L10.2649 8.36624L10.2999 8.47957C10.3791 8.74207 10.4524 9.00041 10.5199 9.25457C10.5907 9.51874 10.6466 9.69624 10.6899 9.78624C11.0482 10.5404 11.8274 11.0829 12.6749 10.7371C13.4632 10.4154 13.6999 9.48124 13.5216 8.72457C13.4949 8.61007 13.4657 8.49615 13.4341 8.38291C13.3091 7.89707 13.2207 7.56957 13.1666 7.40041C13.0553 7.06749 12.8588 6.76954 12.5966 6.53624Z",
					fill: "url(#paint5_linear_17396_28115)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_17396_28115",
				x1: 10,
				y1: 9.26835e-8,
				x2: 10,
				y2: 20,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#012659" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0968DA"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_17396_28115",
				x1: 8.2174,
				y1: 2.50012,
				x2: 11.8507,
				y2: 17.5143,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6BB6FE"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_17396_28115",
				x1: 8.21574,
				y1: 2.49987,
				x2: 11.8491,
				y2: 17.514,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6BB6FE"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_17396_28115",
				x1: 8.21384,
				y1: 2.50044,
				x2: 11.8472,
				y2: 17.5146,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6BB6FE"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_17396_28115",
				x1: 8.21305,
				y1: 2.50069,
				x2: 11.8464,
				y2: 17.5149,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6BB6FE"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_17396_28115",
				x1: 8.21572,
				y1: 2.50041,
				x2: 11.8491,
				y2: 17.5146,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6BB6FE"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_17396_28115",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 20,
					height: 20,
					fill: "white"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgSora);
export default ForwardRef;
